import clsx from 'clsx';
import React from 'react';
import GlobalContext, { titleEnding } from '../../../global';
import { VisibleTaskList } from "./VisibleTaskList";
import { PrivateTaskList } from "./PrivateTaskList";
import { ListFilter } from "./ListFilter";

export default class TaskList extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.list_ref = React.createRef();
    // back from a task opened here: its row is scrolled into view again (see rememberTask)
    this.opened_task = props.location.state?.task;

    this.state = {
      category: props.location.state?.category === "private" ? "private" : "public",
    };
  }

  componentDidMount() {
    document.title = "Список задач" + titleEnding;

    window.scrollTo(0, 0);
  }

  updateTasks(props) {
    this.list_ref.current?.getMoreTasks(props);
  }

  setCategory(category) {
    this.opened_task = undefined; // only the list we came back to scrolls to the task
    this.setState({ category, });
  }

  rememberTask(id) {
    this.props.history.replace({ ...this.props.location, state: { ...this.props.location.state, task: id, }, });
  }

  render() {
    return (
      <div className="main-content">
        <div className="top-text">
          <div className="task-title--flex">
            <h1 className="header">Задачи</h1>
            {this.context.token && <div className="task-title__switch">
              <button
                className={clsx("task-category-button", this.state.category === "public" && "selected")}
                aria-pressed={this.state.category === "public"}
                onClick={() => this.setCategory("public")}
              >
                Публичные
              </button>
              <button
                className={clsx("task-category-button", this.state.category === "private" && "selected")}
                aria-pressed={this.state.category === "private"}
                onClick={() => this.setCategory("private")}
              >
                Мои
              </button>
            </div>}
          </div>
          <p className="task-list-description">{this.state.category === "private" ? "Это задачи, которые вы загрузили на Sort\u00A0Me." : "Это огромная база задач по всем существующим темам."}</p>
          <div className="task-list-container">
            <ListFilter category={this.state.category} updateTasks={props => this.updateTasks(props)} {...this.props} />
            {this.state.category === "private" ?
              <PrivateTaskList ref={this.list_ref} {...this.props} /> :
              <VisibleTaskList ref={this.list_ref} restore_task={this.opened_task} onOpenTask={id => this.rememberTask(id)} />}
          </div>
        </div>
      </div>
    );
  }
}
